import { NonIndexRouteObject } from 'react-router';

import { HomeRoutes } from '../../../../../RouteConstants';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage, ErrorBoundary } from '@components/ErrorBoundary';

export const SuperAdminLoginPublicRoutes: NonIndexRouteObject[] = [
  {
    id: 'admin-login',
    path: HomeRoutes.adminLogin,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const Login = (await import('../../../../../../Modules/Authentication/Login/Login')).default;
      const { LoginAdminAction } = await import(
        '../../../../../../Modules/Authentication/Login/utils/login.admin.action'
      );

      return {
        element: (
          <HomeLayoutLoginRoutes
            content={
              <ErrorBoundary>
                <Login isAdminLogin={true} />
              </ErrorBoundary>
            }
          />
        ),
        errorElement: <RouteErrorPage />,
        action: LoginAdminAction,
      };
    },
  },
];
